@if (isPreviewDisplayed && modal) {
    <iu-modal-ui
        #modalRef
        [angularStyle]="modalStyle"
        [appendTo]="appendTo"
        [hasFooter]="true"
        (closeModalEmitter)="isPreviewDisplayed = false; showError = false">
        <ng-container
                [ngTemplateOutlet]="mainTemplate"
                [ngTemplateOutletContext]="{
        dataUrl: dataUrl,
        innerHtmlContent: innerHtmlContent,
        isImagePreview: isImagePreview,
        modal: modal,
        imgStyle: imgStyle,
        fileName: fileName,
        showError: showError,
        isDocPreview: isDocPreview,
        mediaType: mediaType,
      }"/>
        <ng-content/>
    </iu-modal-ui>
}

@if (overlay) {
    <iu-prime-overlay #opRef [appendTo]="appendTo" [handleAlign]="handleAlign.bind(this)">
        <div class="usearch-file-preview">
            <ng-container
                    [ngTemplateOutlet]="mainTemplate"
                    [ngTemplateOutletContext]="{
          dataUrl: dataUrl,
          innerHtmlContent: innerHtmlContent,
          isImagePreview: isImagePreview,
          modal: modal,
          imgStyle: imgStyle,
          fileName: fileName,
          showError: showError,
          isDocPreview: isDocPreview,
          mediaType: mediaType,
        }"/>
        </div>
    </iu-prime-overlay>
}

@if (isPreviewDisplayed && !modal && !overlay) {
    <ng-container
            [ngTemplateOutlet]="mainTemplate"
            [ngTemplateOutletContext]="{
      dataUrl: dataUrl,
      innerHtmlContent: innerHtmlContent,
      isImagePreview: isImagePreview,
      modal: modal,
      imgStyle: imgStyle,
      fileName: fileName,
      showError: showError,
      isDocPreview: isDocPreview,
      mediaType: mediaType,
    }"/>
}

<ng-template
    #mainTemplate
    let-dataUrl="dataUrl"
    let-fileName="fileName"
    let-imgStyle="imgStyle"
    let-innerHtmlContent="innerHtmlContent"
    let-isDocPreview="isDocPreview"
    let-isImagePreview="isImagePreview"
    let-isPreviewDisplayed="isPreviewDisplayed"
    let-mediaType="mediaType"
    let-modal="modal"
    let-showError="showError">
    @if (hasPreviewError) {
        <p>
            {{ 'previewDoc.noPreview' | translate }}
        </p>
    }

    @if ( (dataUrl || innerHtmlContent)) {
        @if (isImagePreview) {
            <img
                    class="previewImg"
                    [alt]="fileName"
                    [attr.data-cy]="modal ? 'modal-preview-data' : 'preview-data'"
                    [width]="'100%'"
                    [height]="'max-content'"
                    [ngSrc]="dataUrl"
                    [ngStyle]="imgStyle"/>
        }

        @if (['sh', 'txt', 'csv', 'xlsx'].includes(extension) && innerHtmlContent) {
            <div class="other-viewer" [innerHTML]="innerHtmlContent"></div>
        } @else {
            @switch (extension) {
                @case ('pdf') {
                    <iu-pdf-viewer [attr.data-cy]="modal ? 'modal-preview-data' : 'preview-data'" [dataUrl]="dataUrl"/>
                }
                @case ('xml') {
                    <iu-xml-viewer [attr.data-cy]="modal ? 'modal-preview-data' : 'preview-data'" [blob]="blob"/>
                }
            }
        }

        @if (showError) {
            {{ 'previewDoc.noExtension' | translate }}
        }

        <!-- TODO: check if this is necessary -->
        <ng-template #docError>
            @if (isDocPreview) {
                <p>
                    {{ 'previewDoc.noPreview' | translate }}
                    <a target="_blank" [download]="fileName"
                       [href]="dataUrl"> {{ 'previewDoc.downloadIt' | translate }}</a>
                </p>
            }
        </ng-template>
    }
</ng-template>
